<template>
  <div :class="{'food-cart': true, inline: inline, empty: item_count == 0}" v-show="item_count > 0">
    <div v-if="!inline" class="cart-bug" @click="show_cart = !show_cart">
      <img src="../img/shopping-cart.svg" alt="">
      <span class="count">{{ item_count }}</span>
    </div>
    <h3 v-if="inline && !hideButtons">Your Selections</h3>
    <div class="full-cart" v-if="show_cart || inline">
      <div class="items">
        <div class="item" v-for="item in cart">
          <div class="name">
            <div class="food-name">{{ item.name }}</div>
            <div class="serving">{{ item.option }}</div>
            <div class="price">{{ item.price|moneyfmt }}</div>
          </div>
          <div class="qty">
            <input type="number" @input="updateQty(item, $event)" :value="item.qty" min="1" step="1">
          </div>
          <a href="#" class="remove" @click.prevent="removeItem(item)"></a>
        </div>
      </div>

      <hr>
      <div class="total">
        <span>Subtotal: </span>
        <span>{{ total|moneyfmt }}</span>
      </div>
      <div class="note" v-if="inline">
        <p><strong>Note: This calculator gives you an estimate only!</strong> No payment is required to submit this form. You will be contacted to discuss the details.</p>
      </div>
      <div class="menu-nav" v-if="!hideButtons">
        <a v-if="prevMenu" :href="prevMenu.link">&laquo; {{ prevMenu.title.rendered }}</a>
        <a v-if="nextMenu" :href="nextMenu.link">{{ nextMenu.title.rendered }} &raquo;</a>
      </div>
      <div class="buttons" v-if="!hideButtons">

        <a href="/catering-order/" target="_self">Finish</a>
        <a href="#" @click.prevent="empty">Empty Cart</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'floating-cart',
    props: ['inline', 'hideButtons'],
    data () {
        return {
            show_cart: false,
            nextMenu: null,
            prevMenu: null,
        }
    },
    computed: {
        ...mapGetters(['cart', 'item_ids', 'total']),
        item_count () {
            return this.item_ids.length
        },
    },
    filters: {
        moneyfmt (num) {
            let n = Number(num)
            return n.toLocaleString('en-US', {style: 'currency',
                currency: 'USD', currencyDisplay: 'symbol',
                // minimumFractionDigits: 0,
                // maximumFractionDigits: 0,
            })
        },
    },
    methods: {
        removeItem (item) {
            this.$store.dispatch('removeItem', item)

            if (this.item_count == 0) {
                this.show_cart = false
            }
        },
        updateQty (item, event) {
            // console.log(event)
            let value = Math.round(event.target.value)
            if (value != event.target.value) {
                event.target.value = value
            }
            this.$store.dispatch('changeQty', {item: item, qty: value})
        },
        empty () {
            this.$store.dispatch('setCart', {})
        },
    },

    async mounted () {
        if (this.inline && !this.hideButtons) {
            try {
                let menuModel = new wp.api.models.Fft_catering_menu({id: wpajax.post_id})
                let currentMenu = await menuModel.fetch()

                if (currentMenu.acf.previous_menu) {
                    menuModel = new wp.api.models.Fft_catering_menu({id: currentMenu.acf.previous_menu})
                    this.prevMenu = await menuModel.fetch()
                }
                if (currentMenu.acf.next_menu) {
                    menuModel = new wp.api.models.Fft_catering_menu({id: currentMenu.acf.next_menu})
                    this.nextMenu = await menuModel.fetch()
                }
            }
            catch (ex) {
            }
        }
    }
}
</script>

<style lang="scss">
.food-cart {
  position: absolute;
  background: white;
  left: 50%;
  transform: translateX(-50%);
}

.inline.food-cart {
  position: static;
  background: transparent;
  left: auto;
  transform: none;
}
.sidebar .inline.food-cart {
  color: white;
}

@media only screen and (min-width: 48em) {
  .food-cart {
    left: auto;
    transform: none;
  }
}
.cart-bug {
  cursor: pointer;
  img {
    vertical-align: text-bottom;
    margin-right: 4px;
  }
  span {
    color: inherit;
  }
}
.full-cart {
  display: flex;
  flex-direction: column;
  padding: 8px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
}
.inline .full-cart {
  padding: 0;
  box-shadow: none;
}
.full-cart .item {
  flex: 0 1 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.75rem;
  margin-top: 0.5rem;
  padding: 1rem 1.6rem 1.0rem;
}
.full-cart .item .name {
  flex: 1 0 66%;
}
.full-cart .item .qty {
  flex: 1 1 25%;
  margin: 0 0.25rem;
}
.full-cart .item input {
  margin-bottom: 0;
  padding-right: 2px;
}
.full-cart .item .remove {
  width: 24px;
  height: 24px;
  background: url('../img/x-square.svg') center center no-repeat transparent;
}

.sidebar .inline .full-cart .item .remove {
  width: 24px;
  height: 24px;
  background: url('../img/x-white.svg') center center no-repeat transparent;
}
.full-cart hr {
  width: 100%;
  height: 1px;
}
</style>
